















































































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import AddCommunication from "@/employer/components/communications/AddCommunication.vue";
import CommunicationNavigation from "@/employer/components/communications/CommunicationNavigation.vue";
import CommunicationRow from "@/employer/components/communications/CommunicationRow.vue";
import HowItWorksWidget from "@/employer/components/shared/HowItWorksWidget.vue";
import * as routes from "@/employer/route-names";
import { Communication, PartnerEmployersSearchFields } from "@/employer/types";
import { CommunicationPortal } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { usePartnerStore } from "@/employer/store/partner";
import { useCommunicationStore } from "@/shared/store/communication";

const initialSearchTerms: PartnerEmployersSearchFields = {
      employerName: "",
      employerId: "",
      taxId: "",
      externalEmployerId: "",
  };
@Component({
  components: {
    CommunicationRow,
    AddCommunication,
    CommunicationNavigation,
    HowItWorksWidget
  }
})
export default class CommunicationsTab extends Vue {
  userStore = useUserStore();
  partnerStore = usePartnerStore();
  communicationStore = useCommunicationStore();

  @Prop()
  accountHolderRoute: string;

  @Prop()
  employerRoute: string;

  @Prop()
  partnerId: number;

  @Prop()
  portal: CommunicationPortal;

  showAdd = false;
  records: Communication[] = [];
  searchTerm = { ...initialSearchTerms };

  mounted () {
    this.load();
  }

  @Watch("portal")
  onPortalChange () {
    this.load();
  }

  load () {
    this.communicationStore.loadPartnerEmployers(this.partnerId);
    this.partnerStore.loadPartnerCommunications({partnerId: this.partnerId, portal: this.portal})
        .then(_ => this.records = this.userStore.communications[this.portal]);
  }

  get widgetAdd () {
    return this.portal === CommunicationPortal.Employee ? `<b>Add</b> a new communication tile for display on the account holder portal.` :
        `<b>Add</b> a new communication tile for display on the employer portal.`;
  }

  get widgetEnter () {
    return this.portal === CommunicationPortal.Employee ? `<b>Enter</b> a display start date, the subject and message, as well as an optional image and call to action link. Don’t forget to set the priority. Then assign it to the groups who should see it. Preview your tile and when ready <b>Save</b> to activate.` :
        `<b>Enter</b> a display start date, the subject and message, as well as an optional image and call to action link. Don’t forget to set the priority. Preview your tile and when ready <b>Save</b> to activate.`;
  }

  get widgetInactivate () {
    return this.portal === CommunicationPortal.Employee ? `<b>Inactivate</b> tiles at any time by setting a future Display End Date, or set the current date to inactivate immediately.` :
        `<b>Inactivate</b> tiles at any time by setting a future Display End Date, or set the current date to inactivate immediately.`;
  }

  get accountHolder () {
    return this.accountHolderRoute ? this.accountHolderRoute : routes.PartnerCommunicationsAccountHolder;
  }

  get employer () {
    return this.employerRoute ? this.employerRoute : routes.PartnerCommunicationsEmployer;
  }

  get isPartner () {
    return !!this.partnerId;
  }

  get addNewSubtitle () {
    return this.portal === CommunicationPortal.Employee ? "Add new account holder message." : "Add new employer user message.";
  }

  addCommunication (): void {
    this.showAdd = true;
  }

  cancel (): void {
    this.showAdd = false;
  }
}
